'use client';

import React from 'react';

import { RedisTreatment } from '../../../lib/redis/types/RedisTreatment';

import SortAndFilterTreatmentsProvider from './context/SortAndFilterTreatmentsContext';
import SortAndFilterConfigProvider from './context/SortAndFilterConfigContext';
import TreatmentSortContext from './TreatmentSort/context/TreatmentSortContext';
import TreatmentFilterContext from './TreatmentFilter/context/TreatmentFilterContext';
import SortAndFilterResultsProvider from './SortAndFilterResults/SortAndFilterResultsContext';

type SortAndFilterConfigProviderProps = React.ComponentProps<typeof SortAndFilterConfigProvider>;

interface Props {
    children: React.ReactNode;
    urlKey: string;
    treatments: RedisTreatment[];
    pageConfig?: SortAndFilterConfigProviderProps['pageConfig'];
    globalConfig?: SortAndFilterConfigProviderProps['globalConfig'];
    onSortChange?: () => void;
    onFilterChange?: () => void;
}

const TreatmentSortAndFilter = ({
    children,
    urlKey,
    treatments,
    pageConfig,
    globalConfig,
    onSortChange,
    onFilterChange
}: Props) => (
    <SortAndFilterConfigProvider pageConfig={pageConfig} globalConfig={globalConfig}>
        <SortAndFilterTreatmentsProvider treatments={treatments}>
            <TreatmentSortContext urlKey={urlKey} onSortChange={onSortChange}>
                <TreatmentFilterContext urlKey={urlKey} onFilterChange={onFilterChange}>
                    <SortAndFilterResultsProvider>{children}</SortAndFilterResultsProvider>
                </TreatmentFilterContext>
            </TreatmentSortContext>
        </SortAndFilterTreatmentsProvider>
    </SortAndFilterConfigProvider>
);

export default TreatmentSortAndFilter;
